import { createFileRoute } from '@tanstack/react-router';
import { RequireRole } from '../components/RequireRole';
import { PartnerForm } from '../features/partners/PartnerForm';

export const Route = createFileRoute('/partners/new')({
  component: () => (
    // Le RP d'un partner agrégateur crée les réseaux qu'il recrute. Le vrai
    // filtre est côté API (`PartnersService.applyAggregatorCreationDefaults`
    // rejette un RP non agrégateur) — ici c'est de l'UX : un RP ordinaire ne
    // voit de toute façon aucun bouton menant à cette route.
    <RequireRole allow={['admin', 'responsable_partenaire']}>
      <PartnerForm />
    </RequireRole>
  ),
});
